<template>
    <a :target="item.url.startsWith('/') ? '_self' : '_blank'" :href="item.url">
        <div class="info-box">
            <span
                class="info-box-icon"
                :style="{ backgroundColor: item.color }"
            >
                <i :class="item.icon"></i>
            </span>
            <div class="info-box-content">
                <span class="info-box-text">{{ item.name }}</span>
                <span class="info-box-number">
                    {{ item.description }}
                </span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        item: Object,
    },
};
</script>
